import React from "react";
import SectionSimpleLookup from "./SectionSimpleLookup";

export default function SectionPreise({
                                          form,
                                          setForm,
                                          restaurantPrices,
                                          restaurantPricesLoading,
                                          restaurantPricesError,
                                      }) {
    return (
        <SectionSimpleLookup
            form={form}
            setForm={setForm}
            field="restaurant_price_ids"
            items={restaurantPrices}
            loading={restaurantPricesLoading}
            error={restaurantPricesError}
            emptyText="Keine Preise vorhanden. Lege zuerst Preise an."
        />
    );
}
